import React from "react";

export const SELECTED_COUNTRY_KEY = "selectedCountry";

export const LANGUAGE_KEY = "lang";

const CountryContext = React.createContext();

export default CountryContext;
